import parse from "html-react-parser";

import { useLanguage } from "~/context/LanguageContext";

import i18n from "./i18n";

export default function ArticleConclusion() {
  const { lang } = useLanguage();
  const t = i18n[lang];

  return (
    <>
      <div className="cs-height_140 cs-height_lg_80"></div>
      <div className="container">
        <div className="row col-lg-10 offset-lg-1">
          <h2
            className="cs-font_38 cs-m0 wow fadeInUp text-center"
            data-wow-duration="0.8s"
            data-wow-delay="0.2s"
          >
            {t.title}
          </h2>
          <div className="cs-height_60 cs-height_lg_45"></div>
          {parse(t.content)}
        </div>
      </div>
      <div className="cs-height_145 cs-height_lg_80"></div>
    </>
  );
}
